import QRCode from 'qrcode.react';
import { Button } from 'components';
import { Bank } from 'hooks/webapi/client/useBanksQuery';
import { composeQRPayment } from 'utils/bankAccountFormat';
import CopyValue from 'components/CopyValue/CopyValue';
import s from './PaymentDetails.module.scss';
import { useTranslation } from 'react-i18next';

function PaymentDetails({ value }: { value: Bank }) {
  const DEFAULT_FEE = 0.01;
  const { t } = useTranslation();

  const qrPayment = (bankDetails: any) => {
    return composeQRPayment({
      countryCode: 'CZ',
      bankAccount: bankDetails.accountNumber,
      variableSymbol: bankDetails.clientIdentificationNumber,
      amount: DEFAULT_FEE,
      currency: 'CZK',
    });
  };

  const downloadQR = () => {
    const canvas = document.getElementById('qrCodeEl') as HTMLCanvasElement;
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');

    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `Bank details.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div className={s.box} data-test="paymentDetails">
      <div className={s['bank-row']}>
        <div className={s['bank-row-content']}>
          <div className={s['qr-code']}>
            <QRCode
              size={105}
              value={qrPayment(value)}
              id="qrCodeEl"
              data-test="paymentDetails-qrCode"
            />
            <Button
              onClick={downloadQR}
              outline
              wide
              size="s"
              className={s['qr-mobile-download']}
              dataTest="paymentDetails-btn"
            >
              {t('identification_manual:download')}
            </Button>
          </div>
          <div className={s['qr-notice']} data-test="paymentDetails-qrNotice">
            {t('identification_manual:qrcode_notice')}
            <span>{t('identification_manual:qrcode_tooltip')}</span>
          </div>
        </div>
        <div className={s['bank-separator']}>
          <span className={s['bank-separator-badge']}>
            {t('identification_manual:bank_separator')}
          </span>
        </div>
      </div>
      <CopyValue
        label={t('identification_manual:payee')}
        value={value.receiver}
        copyLabel={t('identification_manual:copy')}
        confirmLabel={t('identification_manual:copied')}
        dataTest="paymentDetails-copyValue-payee"
      />
      <div className={s['details-separator']} />
      <CopyValue
        label={t('identification_manual:bank_name')}
        value={value.bankName}
        copyLabel={t('identification_manual:copy')}
        confirmLabel={t('identification_manual:copied')}
        dataTest="paymentDetails-copyValue-bankName"
      />
      <div className={s['details-separator']} />
      <CopyValue
        label={t('identification_manual:account_number')}
        value={value.accountNumber}
        copyLabel={t('identification_manual:copy')}
        confirmLabel={t('identification_manual:copied')}
        dataTest="paymentDetails-copyValue-accountNumber"
      />
      <div className={s['details-separator']} />
      <CopyValue
        label={t('identification_manual:variable_symbol')}
        value={value.clientIdentificationNumber}
        copyLabel={t('identification_manual:copy')}
        confirmLabel={t('identification_manual:copied')}
        dataTest="paymentDetails-copyValue-symbol"
      />
    </div>
  );
}

export default PaymentDetails;
